function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BhutanFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#FF6230",
      fillRule: "evenodd",
      d: "M0 3h24v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FECA00",
      fillRule: "evenodd",
      d: "M0 3v18L24 3H0Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("g", {
      filter: "url(#b)",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M3.287 15.247s-1.128 1.027-.234 1.08c.894.055.726.6 1.458.004.73-.596.022.095.997-.04.975-.136 1.462-1.326 1.977-1.245.515.082.217-.108.65.407.434.514 1.195-.578.789.18-.406.759-.569 1.517.027 1.49.596-.027.84-.38 1.11-.759.271-.379 2.384.921 1.41-.379-.976-1.3-1.354.143-1.436-.534-.08-.678-.275-1.03.186-.705.46.325 1.544.244.704-.569-.84-.812-.723-1.029-.967-.812-.244.217-.84-.813 0-.948.84-.136 1.807.325 2.132.569.325.243 1.327-.055 1.544.433.216.488.948.569 1.137.867.19.298.055 1.76 1.599 1.68 1.543-.082 2.031-.867 1.381-1.49-.65-.624-.596-1.761-1.273-1.22-.677.542-1.652.461-1.652-.19 0-.65.298-.757.243-1.272-.054-.515-.108-.298.894-.271 1.002.027.65 0 1.382-.352.731-.352 1.219 1.192 1.517.054.298-1.137-.109-2.302-.921-1.842-.813.46-.786 1.598-1.815.705-1.03-.895-1.517-.434-1.192-.922.325-.487-.081-.84.65-.514.731.325.515.433 1.138.514.623.082 3.927.488 3.196-.19-.731-.676-1.433-.566-1.542-1-.108-.433.338-.324.988-.568.65-.244.379-1.49-.244-1.246s-.57 1.327-1.843.65c-1.46.635-1.235.316-1.978-.76-.65-.515-1.003-.542-2.113.054-.877.361-1.61 1.029-1.15 1.923.461.894 1.558 2.577.962 2.685-.596.109-2.736-1.49-3.982-.65s-1.926 1.657-2.332 2.632c-.406.975-1.721 1.543-2.046 1.543-.325 0-.783.574-1.351 1.008Z",
        clipRule: "evenodd"
      })
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsxs("filter", {
      id: "b",
      width: "21.314",
      height: "15.461",
      x: ".709",
      y: "3.662",
      colorInterpolationFilters: "sRGB",
      filterUnits: "userSpaceOnUse",
      children: [/*#__PURE__*/_jsx("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
      }), /*#__PURE__*/_jsx("feOffset", {}), /*#__PURE__*/_jsx("feGaussianBlur", {
        stdDeviation: "1"
      }), /*#__PURE__*/_jsx("feColorMatrix", {
        values: "0 0 0 0 0.866667 0 0 0 0 0.184314 0 0 0 0 0 0 0 0 0.38 0"
      }), /*#__PURE__*/_jsx("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_621_4614"
      }), /*#__PURE__*/_jsx("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_621_4614",
        result: "shape"
      })]
    })
  })]
}));
//# sourceMappingURL=Bhutan.js.map